import React from "react";
import "./about.css";
import ME from "../../assets/me-about.jpeg";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { RiTaskLine } from "react-icons/ri";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container abount__container">
        <div className="about__me">
          <div className="about__me_image">
            <img src={ME} alt="ijaz bacha picture" />
          </div>
        </div>

        <div className="about__contain">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>2+ Years Working</small>
            </article>

            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Clients</h5>
              <small>10+ Clients Worldwide</small>
            </article>

            <article className="about__card">
              <RiTaskLine className="about__icon" />
              <h5>Projects</h5>
              <small>30+ Completed</small>
            </article>
          </div>
          <p>
            Lover of all things <strong>Android</strong> and <strong>Web</strong>. I am an experienced
            professional React and React native developer. I have strong
            problem-solving skills and the ability to learn new technologies
            quickly. Eager to join a team of talented developers and help build
            world-class web and mobile apps.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
